import { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { safeStorage } from '../utils/safeStorage';
import './ConfirmationPage.css'; // Assuming the CSS is in this file

function ConfirmationPage() {
  const [qrCode, setQrCode] = useState('');
  const [totalPaidAmount, setTotalPaidAmount] = useState('');
  const [qrCodeBase64, setQrCodeBase64] = useState('');
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [storageUnavailable, setStorageUnavailable] = useState(false);

  // useRef to store the interval ID so we can clear it later
  const statusIntervalRef = useRef(null);

  const checkPaymentStatus = useCallback(async (paymentIdToCheck) => {
    if (!paymentIdToCheck) return;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/payments/status/${paymentIdToCheck}`);
      const paymentStatus = response.data.status;

      if (paymentStatus === 'approved') {
        setPaymentConfirmed(true);
        clearInterval(statusIntervalRef.current);
      }
    } catch (error) {
      console.error('Erro ao verificar o status do pagamento:', error);
    }
  }, []);

  useEffect(() => {
    const storedQrCode = safeStorage.getItem('qr_code');
    const storedTotalPaidAmount = safeStorage.getItem('total_paid_amount');
    const storedQrCodeBase64 = safeStorage.getItem('qr_code_base64');
    const storedPaymentId = safeStorage.getItem('payment_id');

    if (storedQrCode && storedTotalPaidAmount && storedQrCodeBase64 && storedPaymentId) {
      setQrCode(storedQrCode);
      setTotalPaidAmount(storedTotalPaidAmount);
      setQrCodeBase64(storedQrCodeBase64);

      statusIntervalRef.current = setInterval(() => {
        checkPaymentStatus(storedPaymentId);
      }, 1000);
    } else {
      setStorageUnavailable(true);
    }

    return () => clearInterval(statusIntervalRef.current);
  }, [checkPaymentStatus]);

  // Display message when storage is unavailable (e.g. private mode)
  if (storageUnavailable) {
    return (
      <div className="confirmation-container">
        <h1 className="confirmation-title">Ingressos Edub</h1>
        <div className="confirmation-success">
          <p>Os dados do pagamento não estão disponíveis. Isso pode acontecer se você estiver usando o modo privado do navegador.</p>
          <p>Por favor, use o modo normal do navegador e refaça o processo de compra.</p>
          <Link to="/" style={{ color: '#4CAF50', marginTop: '20px', display: 'inline-block' }}>Voltar para a página inicial</Link>
        </div>
      </div>
    );
  }

  // Display a success message if the payment is confirmed
  if (paymentConfirmed) {
    return (
      <div className="confirmation-container">
        <h1 className="confirmation-title">Ingressos Edub</h1>
        <div className="confirmation-success">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
            <path fill="#4caf50" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
            <path fill="#ccff90" d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"></path>
          </svg>
          <p>Pagamento realizado com sucesso! O nome foi inserido na lista, agora apenas apresente o documento na entrada do evento!</p>
        </div>
      </div>
    );
  }

  // If payment is not yet confirmed, show the payment instructions
  return (
    <div className="confirmation-container">
      <h1 className="confirmation-title">Ingressos Edub</h1>
      <p className="confirmation-subtitle">Pague R$ {totalPaidAmount} via Pix</p>
      <p className="confirmation-deadline">Vencimento: 15 minutos</p>

      {qrCodeBase64 && (
        <div className="confirmation-qr-container">
          <img className="confirmation-qr" src={`data:image/png;base64,${qrCodeBase64}`} alt="QR Code" />
        </div>
      )}

      <div className="confirmation-code">
        <p>Código de pagamento:</p>
        <input className="confirmation-code-input" value={qrCode} readOnly />
      </div>

      <div className="confirmation-instructions">
        <p>Como pagar?</p>
        <ol>
          <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
          <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
          <li>Pronto! O pagamento será creditado na hora e você receberá um e-mail de confirmação.</li>
        </ol>
      </div>
    </div>
  );
}

export default ConfirmationPage;
